import { AppState, AppStateActionParams } from 'records/AppState';
import { acceptEula, getEula, getTosLink } from 'services/eulaService';

export interface EulaActions {
  getEula: (actionParams: AppStateActionParams) => Promise<AppState>;

  acceptEula: (actionParams: AppStateActionParams) => Promise<AppState>;

  getTosLink: (
    actionParams: AppStateActionParams,
    projectType: string
  ) => Promise<AppState>;
}

const eulaActions = {
  getEula: async ({ state }: AppStateActionParams): Promise<AppState> => {
    const eula = await getEula();

    return state().set('eula', eula);
  },

  acceptEula: async ({ state }: AppStateActionParams): Promise<AppState> => {
    const hasAccepted = await acceptEula();

    return state().setIn(['eula', 'accepted'], hasAccepted);
  },

  getTosLink: async (
    { state }: AppStateActionParams,
    projectType: string
  ): Promise<AppState> => {
    const tosLink = await getTosLink(projectType);
    return state().set('tosLink', tosLink);
  },
};

export default eulaActions;
